import React from 'react';
import ReactTable from "react-table";
import treeTableHOC from "react-table/lib/hoc/treeTable";
import {
	Card,
	CardBody,
	CardTitle,
	Button, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input, Row
} from 'reactstrap';
import "react-table/react-table.css";
import * as data from "../tables/reactable-data";
import { auth } from "../../Api";
import { AutoComplete, Input as AInput } from 'antd';
import 'react-phone-number-input/style.css'
import LocalPhoneField from '../../components/people/localPhoneField'
import { dialCodeFor, toInternational, phoneProblem, formatPhone, phoneWithCount } from '../../utils/phone'
import { formatServerMessage } from '../../utils/serverErrors'
import { personName, isSharedPhoneReply, sharedPhoneState, confirmedSharedPhoneRequest } from '../../utils/people'
import SharedPhoneModal from '../../components/people/sharedPhoneModal'
import { deleteSucceeded, deleteFailedMessage, DELETE_UNREACHABLE } from '../../utils/deleteReply'
import { titleCell } from '../../utils/tables'
import { GuardDutyToggle } from '../../components/people/guardDutySwitch'
import { isPrivateAccount } from '../../utils/accountType'

const { getCode, getName } = require('country-list');

const TreeTable = treeTableHOC(ReactTable);

class ReSellers extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			checked: false,
			open: false,
			modal: false,
			alertModal: false,
			obj: {},
			objData: {},
			jsonData: [],
			originData: [],
			autoOptions:[],
			data: data.makeData(),
			treedata: data.treedata,
			companyName: '',
			defaultPageSize: 10,
			defaultCountry: null
		};
		this.toggle = this.toggle.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}
	componentDidMount() {
		var defaultPageSize = localStorage.getItem('defaultPageSize')
		if (defaultPageSize != undefined) {
			this.setState({
				defaultPageSize: defaultPageSize
			})
		}
		let companyId = localStorage.getItem('companyId')
		let companyName = localStorage.getItem('companyName')
		this.setState({
			companyId: companyId,
			companyName: companyName
		})
		auth.getCompany({ id: companyId })
			.then((res) => {
				if (res.data.code == 200) {
					let companyData = res.data.message.users[0];
					this.setState({ defaultCountry: companyData.countrycode, dialCode: dialCodeFor(companyData.countrycode) });
				}
			});
		var req = {}
		req.company_id = companyId
		auth.getGuard(req)
			.then((res) => {
				console.log("skjdkfjsk--------clients", companyId, res.data.message.users);
				if (res.data.code == 200) {
					this.setState({
						jsonData: res.data.message.users,
						originData: res.data.message.users,
						// In a free trial with the most guards it may have: Add New Guard says so (laravel App\Trial)
						trialGuardLimit: res.data.message.trial_guard_limit || null
					})
				}
			});
	}

	// Add New Guard: the guard form, or at once the trial's limit when the company already has its 2 guards (the
	// server refuses a third anyway)
	addGuard = () => {
		if (this.state.trialGuardLimit) {
			this.setState({ limitModal: true })
			return
		}
		this.props.history.push('/guard-edit/null')
	}

	// Closes the delete popup (its Cancel and a click outside it)
	alertToggle = () => {
		this.setState({ alertModal: false });
	}
	toggle() {
		this.setState({
			modal: !this.state.modal
		});
	}

	handleChange(index) {
		console.log("checked:", index)
		let { jsonData } = this.state;
		jsonData[index].islogged = !jsonData[index].islogged
		console.log(jsonData[index].islogged)
		this.setState({ jsonData });
	}

	setPhoneNumber = (event) => {
		console.log("event of phone:", event)
		// A copy, so the field shows what is typed
		this.setState({ obj: Object.assign({}, this.state.obj, { phone: event }) })
	}
	
	handleSubmit = (event) => {
		event.preventDefault();
		let { jsonData, obj, objData } = this.state;
		console.log(["guard edit:", obj])
		let req = {}
		req.id = objData.id;
		req.firstname = event.target.firstname.value;
		req.secondname = event.target.secondname.value;
		req.countrycode = this.state.selectedCountry || this.state.defaultCountry;
		// The local number completed with the company's dialling code
		req.phone = toInternational(obj.phone, this.state.dialCode);
		if (req.phone === null) {
			window.alert(phoneProblem(obj.phone, this.state.dialCode))
			return
		}
		req.avatar = objData.avatar
		req.CID = objData.CID
		req.company_id = objData.company_id
		req.district_id = objData.district_id
		req.districtmanager_id = objData.districtmanager_id
		req.supervisor_id = objData.supervisor_id
		req.client_id = objData.client_id
		req.timezone = objData.timezone

		// The form stays open until the guard is saved (a question or a refusal leaves it as typed)
		this.saveQuickEdit(req)
	}

	// A phone number someone else in the company also has is asked about first (code 409); Yes sends
	// the save again with confirm_shared_phone. Other refusals (e.g. CID already used) are shown.
	saveQuickEdit = (req) => {
		auth.updateGuard(req)
			.then((res) => {
				if (isSharedPhoneReply(res)) {
					this.setState({ sharedPhone: sharedPhoneState(res, req, 'guard') })
					return
				}
				if (res.data.code != 201) {
					window.alert(formatServerMessage(res.data.message, 'The guard could not be saved.'))
					return
				}
				// Saved: back to the list, loaded again
				this.setState({ modal: false })
				this.componentDidMount()
			})
	}

	// samePerson: the person of another kind the admin said this is (Yes), or null (No, or Continue)
	confirmSharedPhone = (samePerson) => {
		const { req } = this.state.sharedPhone
		this.setState({ sharedPhone: null })
		this.saveQuickEdit(confirmedSharedPhoneRequest(req, samePerson))
	}

	// Reloads the list only after the server has deleted it; a refusal is shown
	deleteRow() {
		const { obj } = this.state
		this.setState({ alertModal: false })
		auth.deleteGuard({ id: obj.idKey })
			.then((res) => {
				if (deleteSucceeded(res)) {
					this.componentDidMount()
				} else {
					window.alert(deleteFailedMessage(res, 'The guard could not be deleted.'))
				}
			})
			.catch(() => window.alert(DELETE_UNREACHABLE))
	}

	handleSearch = (value) => {
		console.log(["searchData.length==value:", value])
		var searchData = [];
		this.state.originData.map((prop, key) => {
			if (prop.firstname.toLowerCase().includes(value.toLowerCase())
				|| prop.secondname.toLowerCase().includes(value.toLowerCase())) {
				searchData.push(prop)
			}
		})
		console.log(["searchData.length==00:", searchData.length])
		this.setState({ jsonData: searchData })
	  };

	  onSizeChange = (size, page) => {
		console.log("size,page::", size, page)
		localStorage.setItem('defaultPageSize', size)
		this.setState({
			defaultPageSize: size
		})
	}
	render() {
		const { data, autoOptions, obj, companyName, defaultPageSize } = this.state;

		const items = []

		const data2 = this.state.jsonData.map((prop, key) => {
			if (prop.active == 1) prop.active = true
			if (prop.active == 0) prop.active = false

			items.push({
				id: prop.id,
				name: personName(prop, 'guard')
			})
			return {
				id: key,
				name: (
					<a onClick={() => this.props.history.push('/guard-info/' + prop.id)} style={{ cursor: "pointer" }}>{personName(prop, 'guard')}</a>
				),
				idKey: prop.id,
				firstnamet: prop.firstname,
				secondname: prop.secondname,
				cid: prop.CID,
				phone: formatPhone(prop.phone),
				// The first number, and "+N" when the person has N more
				phoneShown: phoneWithCount(prop),
				country: getName(prop.countrycode),
				// On duty / Off duty, saved at once (company admins and district managers)
				onDuty: (
					<GuardDutyToggle guardId={prop.id} onDuty={prop.on_duty}
						onChange={(value) => this.setState({ jsonData: this.state.jsonData.map((row) => row.id === prop.id ? Object.assign({}, row, { on_duty: value ? 1 : 0 }) : row) })} />
				),
				client: (prop.client_name ) ?? "",
				location: (prop.location_name ) ?? "",
				supervisor: (prop.supervisor_name ) ?? "",
				// actions column removed per requirements
				duties: (
					<a href="/duty/123"><div>showduties</div></a>
				),
				edit: (
					<div className="justify-content-around">
						<Button className="btn-table-edit" onClick={() => {
							let obj = data2.find(o => o.id === key);
							console.log(["key:", key, obj.name]);
							console.log("obj====:",obj)
							this.setState({
								modal: !this.state.modal,
								obj: obj,
								objData: prop,
								selectedCountry: obj.countrycode
							});
						}}><i className="mdi mdi-lead-pencil" style={{ color: "white" }} /></Button>
						<Button className="btn-table-remove" onClick={() => {
							let obj = data2.find(o => o.id === key);
							console.log(["key:", key, obj.name]);
							this.setState({
								alertModal: !this.state.alertModal,
								obj: obj,
							});
						}}><i className="fas fa-trash-alt" style={{ color: "white" }} /></Button>
					</div>
				),
				linkPage: (
					<div className="panel panel-default">
						<div className="panel-heading">
							<h6 className="panel-title">
								<a onClick={function () {
									console.log(this.state.open)
									this.setState({ open: !this.state.open })
								}.bind(this)} ><i className="fas fa-plus"></i>View</a>
							</h6>
						</div>
						<div className={this.state.open ? "panel-collapse" : "panel-collapse panel-close"}>
							<ul className="list-group">
								<li className="list-group-item"><i className="mdi mdi-view-dashboard mr-10"></i>Dashboard</li>
								<li className="list-group-item"><i className="ti-map-alt mr-10"></i>Districts</li>
								<li className="list-group-item"><i className="mr-2 mdi mdi-account-settings mr-10"></i>Districts Managers</li>
								<li className="list-group-item"><i className="icon-shield mr-10"></i>Guards</li>
								<li className="list-group-item"><i className="mr-2 mdi mdi-account-alert mr-10"></i>Supervisors</li>
								<li className="list-group-item"><i className="mr-2 mdi mdi-account-multiple-outline mr-10"></i>Clients</li>
								<li className="list-group-item"><i className="icon-bell mr-10"></i>Alerts Template</li>
								<li className="list-group-item"><i className="ti-align-left mr-10"></i>Duties</li>
								<li className="list-group-item"><i className="icon-chart mr-10"></i>Billing</li>
							</ul>
						</div>
					</div>
				)
			};
		});



		return <div>
			<Modal isOpen={this.state.modal} toggle={this.toggle}>
				<ModalHeader toggle={this.toggle}><h3>Guard Edit</h3></ModalHeader>
				{
					obj == {} ? <div></div> : <ModalBody>
						<Form onSubmit={this.handleSubmit}>
							{/* <Input type="hidden" name="id" id="id" defaultValue={obj.id} /> */}
							<FormGroup>
								<Label for="name">First name</Label>
								<Input type="text" name="firstname" id="name" defaultValue={obj.firstnamet} />
							</FormGroup>
							<FormGroup>
								<Label for="name">Last name</Label>
								<Input type="text" name="secondname" id="name" defaultValue={obj.secondname} />
							</FormGroup>
							<FormGroup>
								<Label for="age">Phone</Label>
								<LocalPhoneField
									dialCode={this.state.dialCode}
									value={obj.phone}
									onChange={this.setPhoneNumber}
									editing={{ kind: 'guard', id: this.state.objData && this.state.objData.id }}
									suggest />
							</FormGroup>
							<FormGroup style={{ textAlign: "center" }}>
								<Button color="primary" className="modal-btn mr-1" type="submit">Save</Button>
								<Button color="secondary" className="modal-btn ml-1" onClick={this.toggle}>Cancel</Button>
							</FormGroup>
						</Form>
					</ModalBody>}
			</Modal>
			<Modal isOpen={this.state.alertModal} toggle={this.alertToggle}>
				{/* <ModalHeader toggle={this.alertToggle}>Alert Modal</ModalHeader> */}
				<ModalBody className="alert-body">
					<i className="mdi mdi-alert-circle ft-60"></i>
					<h2>Delete this guard?</h2>
					<div>This deletes the guard for good, with all their duties (and those duties alerts and tracking), and signs them out of the app.</div>
					<div className="height-10"></div>
					<FormGroup>
						<Button color="secondary" className="modal-btn ml-1" onClick={this.alertToggle}>Cancel</Button>
						<span>&nbsp;&nbsp;</span>
						<Button color="primary" className="modal-btn mr-1" onClick={() => this.deleteRow()}>Yes, Delete It!</Button>
					</FormGroup>
				</ModalBody>
			</Modal>
			<Modal isOpen={!!this.state.limitModal} toggle={() => this.setState({ limitModal: false })}>
				<ModalBody className="alert-body">
					<i className="mdi mdi-alert-circle ft-60"></i>
					<h2>{this.state.trialGuardLimit}</h2>
					<div className="height-10"></div>
					<FormGroup>
						<Button color="primary" className="modal-btn" onClick={() => this.setState({ limitModal: false })}>OK</Button>
					</FormGroup>
				</ModalBody>
			</Modal>
			<SharedPhoneModal
				isOpen={this.state.sharedPhone != null}
				message={this.state.sharedPhone ? this.state.sharedPhone.message : ''}
				details={this.state.sharedPhone ? this.state.sharedPhone.details : []}
				person={this.state.sharedPhone ? this.state.sharedPhone.person : null}
				onYes={this.confirmSharedPhone}
				onNo={() => this.confirmSharedPhone(null)}
				onCancel={() => this.setState({ sharedPhone: null })} />
			{/*--------------------------------------------------------------------------------*/}
			{/* Start Action table*/}
			{/*--------------------------------------------------------------------------------*/}
			<div className="height-10"></div>
			<Card>
				{/* <CardTitle className="mb-0 p-3 border-bottom bg-light">
					
				</CardTitle> */}
				<CardBody>
					<div className="add-button add-button-top">
						<Button onClick={this.addGuard} className="btn" color="primary" size="lg" active>
							<i className="fas fa-user-plus"></i> Add New Guard
						</Button>
					</div>
					<Row className="table-header">
						<div className="table-title"><i className="fas fa-users"></i><span> Guards - {companyName}</span></div>
						<div style={{ width: 300 }} className="auto-complete">
							<AutoComplete
								dropdownMatchSelectWidth={252}
								style={{
									width: 300,
								}}
								options={autoOptions}
								onSearch={this.handleSearch}
							>
								<AInput size="large" placeholder="Search"/>
							</AutoComplete>
						</div>
					</Row>
					<ReactTable
						columns={[
							{
								Header: "No",
								id: "row",
								maxWidth: 50,
								filterable: false,
								Cell: (row) => {
									return <div>{row.index + 1}</div>;
								}
							},
							{
								Header: "Name",
								accessor: "name"
							},
							{
								Header: "CID",
								accessor: "cid",
								Cell: titleCell,
							},
							{
								Header: "Phone",
								accessor: "phoneShown",
								Cell: titleCell,
							},
							{
								Header: "On duty",
								accessor: "onDuty",
								filterable: false,
								sortable: false,
								minWidth: 80,
								maxWidth: 90,
							},
							// A Private account has no clients or supervisors: only the location
							...(isPrivateAccount() ? [] : [{
								Header: "Client",
								accessor: "client",
								Cell: titleCell,
							}]),
							{
								Header: "Location",
								accessor: "location",
								Cell: titleCell,
							},
							...(isPrivateAccount() ? [] : [{
								Header: "Supervisor",
								accessor: "supervisor",
								Cell: titleCell,
							}]),

							{
								Header: "",
								accessor: "edit",
								minWidth: 100,
								id: "row",
								maxWidth: 100,
								filterable: false,

							},
						]}
						showPaginationBottom={true}
						pageSize={defaultPageSize}
						pageSizeOptions={[5, 10, 15, 20, 30, 40, 50]}
						onPageSizeChange={(size, number) => this.onSizeChange(size, number)}
						className="-striped -highlight"
						data={data2}
					// filterable
					/>
				</CardBody>
			</Card>
			{/*--------------------------------------------------------------------------------*/}
			{/* End Action table*/}
			{/*--------------------------------------------------------------------------------*/}
		</div>
	}
}

export default ReSellers;

